import { Box, Hidden, Paper, Typography } from '@mui/material';
import React, { useContext, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'line-awesome/dist/line-awesome/css/line-awesome.css';
import { AppContext } from '../../../../utils/appContext';
import { getProperties } from '../../../../utils/helpers';
import { IAccommodationMoreInfo } from '../../../../interfaces/huWebsite';

const PrevArrow = (props: any) => {
  const { onClick } = props;
  return (
    <Hidden mdDown>
      <button type="button" data-role="none" className="slick-arrow slick-next" onClick={onClick}>
        <i className={'las la-arrow-right'}></i>
      </button>
    </Hidden>
  );
};

const NextArrow = (props: any) => {
  const { onClick } = props;
  return (
    <Hidden mdDown>
      <button type="button" data-role="none" className="slick-arrow slick-prev" onClick={onClick}>
        <i className={'las la-arrow-left'}></i>
      </button>
    </Hidden>
  );
};

interface IPropertyCard {
  reservation: any;
  room: IAccommodationMoreInfo | undefined;
}

const PropertyCard = ({ reservation, room }: IPropertyCard) => {
  const useStyles = makeStyles()((theme) => {
    return {
      slider: {
        position: 'relative',
        '& i.la-arrow-left, & i.la-arrow-right': {
          fontSize: 18,
          backgroundColor: 'white',
          borderRadius: theme.radius.iconBorderRadius,
          color: 'black',
          padding: 3
        },
        '& button': {
          zIndex: 999,
          bottom: 15,
          top: 'initial',
          left: 'initial',
          '&::before': {
            content: 'none'
          },
          '&.slick-prev': {
            right: 45
          },
          '&.slick-next': {
            right: 15
          }
        },
        '& .slick-list': {
          [theme.breakpoints.down('sm')]: {
            '& img': {
              minHeight: 'auto'
            }
          }
        }
      },
      propertyCard: {
        img: {
          objectFit: 'cover'
        },
        h3: {
          fontSize: 28,
          fontFamily: theme.typography.h1.fontFamily
        },
        p: {
          fontSize: 16,
          fontFamily: theme.typography.body2.fontFamily,
          lineHeight: '26px'
        }
      }
    };
  });

  const { classes } = useStyles();
  const { t } = useTranslation();

  const appContext = useContext(AppContext);

  const [slideIndex, setSlideIndex] = useState<number>(0);

  const sliderSetting = {
    dots: false,
    arrow: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <NextArrow />,
    nextArrow: <PrevArrow />,
    afterChange: (currentSlide: number) => {
      setSlideIndex(currentSlide);
    },
    beforeChange: (current: number, next: number) => {
      setSlideIndex(next);
    }
  };

  const property = getProperties().find((p: any) => p.code === appContext.searchForm[0].property);

  return (
    <Paper elevation={1} square className={classes.propertyCard}>
      <Box className={classes.slider}>
        <Slider {...sliderSetting}>
          {room?.accomodation_pics &&
            room?.accomodation_pics.map((img: string, index: number) => {
              return (
                <img
                  src={img}
                  key={index}
                  alt="image"
                  width={'100%'}
                  height={350}
                  style={{ objectFit: 'cover' }}
                />
              );
            })}
        </Slider>
      </Box>
      <Box p={3}>
        <Typography variant={'body1'} component={'span'}>
          {property.place}
        </Typography>
        <Typography variant={'h3'} component={'h3'}>
          <em>hu</em> {property.title}
        </Typography>
        <Box pt={2} pr={5}>
          <Typography variant={'body1'} component={'p'}>
            {property.locality}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default PropertyCard;
